module.exports = __webpack_public_path__ + "static/media/wp.b4de649c.png";